import basicSettingApi from '@/api/basicSetting/basicSettingApi'

export default {
	name: 'quick-restart',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			isBtnAvailable: false,
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init(){
			let result = await basicSettingApi.validateArrear();
			this.isBtnAvailable = result;
		},
		async applyQuickRestart(){
			let result = await basicSettingApi.applyQuickRestart();
			if(result){
				this.$router.push({name: 'quick-restart-result'});
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/basicSetting/quickRestart/quickRestart.js